"use strict";

function orInfinFilter() {
  return function(value) {
    return value > 0 ? value : "\u221E";
  };
}

angular.module("dokiv")
  .filter("orInfin", orInfinFilter);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/orInfinFilter.js
// module id = 266
// module chunks = 0